import Flickity from "flickity";
import 'flickity-imagesloaded';

const locationsCarousel = ($el) => {
    if (typeof $el !== "undefined" && $el != null) {
        const locationsCarousel = [
            ...$el.querySelectorAll(".js-locations-carousel-rail"),
        ];
        const isDisabledClass = "is-disabled";

        if (
            typeof locationsCarousel !== "undefined" &&
            locationsCarousel != null
        ) {
            /**
             * Set flickity options
             */
            const options = {
                cellAlign: "left",
                contain: false,
                pageDots: false,
                prevNextButtons: false,
                setGallerySize: true,
                imagesLoaded: true,
                wrapAround: false,
            };

            locationsCarousel.forEach((carousel) => {
                /**
                 * Instantiate new flickty
                 */
                const flkty = new Flickity(carousel, { ...options });

                /**
                 * Hook up navigation instance
                 */
                const previousButton =
                    carousel.parentNode.parentNode.querySelector(
                        ".js-locations-carousel-nav-prev"
                    );
                const nextButton = carousel.parentNode.parentNode.querySelector(
                    ".js-locations-carousel-nav-next"
                );

                //prev
                previousButton.addEventListener("click", () => {
                    flkty.previous();
                });

                // next
                nextButton.addEventListener("click", () => {
                    flkty.next();
                });

                /**
                 * Enable or disable nav buttons
                 */
                previousButton.classList.add(isDisabledClass);

                flkty.on("cellSelect", () => {
                    if (!flkty.cells[flkty.selectedIndex - 1]) {
                        previousButton.classList.add(isDisabledClass);
                        nextButton.classList.remove(isDisabledClass);
                    } else if (!flkty.cells[flkty.selectedIndex + 1]) {
                        nextButton.classList.add(isDisabledClass);
                        previousButton.classList.remove(isDisabledClass);
                    } else {
                        previousButton.classList.remove(isDisabledClass);
                        nextButton.classList.remove(isDisabledClass);
                    }
                });

                /**
                 * Hook up progress bar instance
                 */
                let progressBar = carousel.parentNode.parentNode.querySelector(
                    ".js-locations-carousel-progress-bar"
                );

                flkty.on("scroll", function (progress) {
                    progress = Math.max(0, Math.min(1, progress));

                    progressBar.style.width = progress * 100 + "%";
                });
            });
        }
    }
};

export default locationsCarousel;
